/* "Red Wine" by tPenguinLTG
 * https://www.deviantart.com/tpenguinltg/art/Red-Wine-545729607
 */

export default {
  name: 'redWine',
  anchor: 'rgb(255, 0, 0)',
  anchorVisited: 'rgb(255, 0, 0)',
  borderDark: 'rgb(67, 9, 5)',
  borderDarkest: 'rgb(64, 32, 32)',
  borderLight: 'rgb(102, 12, 8)',
  borderLightest: 'rgb(192, 64, 56)',
  canvas: 'rgb(64, 0, 0)',
  canvasText: 'rgb(255, 255, 255)',
  canvasTextDisabled: 'rgb(67, 9, 5)',
  canvasTextDisabledShadow: 'rgb(192, 64, 56)',
  canvasTextInvert: 'rgb(255, 255, 255)',
  checkmark: 'rgb(255, 255, 255)',
  checkmarkDisabled: 'rgb(192, 64, 64)',
  flatDark: 'rgb(67, 9, 5)',
  flatLight: 'rgb(102, 12, 8)',
  focusSecondary: 'rgb(192, 64, 56)',
  headerBackground: 'rgb(64, 0, 12)',
  headerNotActiveBackground: 'rgb(0, 0, 0)',
  headerNotActiveText: 'rgb(239, 44, 33)',
  headerText: 'rgb(255, 255, 255)',
  hoverBackground: 'rgb(192, 0, 0)',
  material: 'rgb(102, 12, 8)',
  materialDark: 'rgb(0, 0, 0)',
  materialText: 'rgb(255, 255, 255)',
  materialTextDisabled: 'rgb(67, 9, 5)',
  materialTextDisabledShadow: 'rgb(192, 64, 56)',
  materialTextInvert: 'rgb(255, 255, 255)',
  progress: 'rgb(192, 0, 0)',
  tooltip: 'rgb(64, 0, 0)',
};
